var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg50Th(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3741",
    "data-name": "Group 3741",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    fill: "rgba(141,198,63,0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16 1 C 11.99334907531738 1 8.226520538330078 2.560270309448242 5.393400192260742 5.393400192260742 C 2.560270309448242 8.226520538330078 1 11.99334907531738 1 16 C 1 20.00664901733398 2.560270309448242 23.77347946166992 5.393400192260742 26.60659980773926 C 8.226520538330078 29.43972969055176 11.99334907531738 31 16 31 C 20.00664901733398 31 23.77347946166992 29.43972969055176 26.60659980773926 26.60659980773926 C 29.43972969055176 23.77347946166992 31 20.00664901733398 31 16 C 31 11.99334907531738 29.43972969055176 8.226520538330078 26.60659980773926 5.393400192260742 C 23.77347946166992 2.560270309448242 20.00664901733398 1 16 1 M 16 0 C 24.8365592956543 0 32 7.163440704345703 32 16 C 32 24.8365592956543 24.8365592956543 32 16 32 C 7.163440704345703 32 0 24.8365592956543 0 16 C 0 7.163440704345703 7.163440704345703 0 16 0 Z",
    stroke: "none",
    fill: "rgba(141,198,63,0.6)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_50th",
    "data-name": "50th",
    transform: "translate(16 20)",
    fill: "#1b453e",
    fontSize: 10,
    fontFamily: "SFProDisplay-Bold, SF Pro Display",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9,
    y: 0
  }, "50"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontSize: 5.833,
    baselineShift: 3.3329999446868896
  }, "th"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg50Th);
export default __webpack_public_path__ + "static/media/50th.d6abb6082c095abcd1c1bfa03652856a.svg";
export { ForwardRef as ReactComponent };